/**
 * DemoBanner — persistent sticky banner shown across all routes when
 * the auth'd user belongs to the demo tenant. Tells visitors what they
 * can do and where to find the "real" sign-up.
 */
import { Info, X } from "lucide-react";
import { useState } from "react";
import { useAuth } from "../context/AuthContext";

export default function DemoBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  // Show only for users in the demo tenant.
  if (!user || user.tenant_id !== "demo") return null;
  if (dismissed) return null;
  return (
    <div
      className="sticky top-0 z-[60] px-3 py-2 bg-gradient-to-r from-[#1FB6C1]/90 to-[#9333EA]/80 text-[#06222a] text-xs sm:text-sm flex items-center gap-2 shadow-md"
      data-testid="demo-banner"
    >
      <Info className="w-4 h-4 shrink-0" />
      <div className="flex-1 leading-tight">
        <span className="font-bold mr-1">DEMO MODE.</span>
        Explore freely — writes are blocked. Data resets nightly. Like what you see?
        <a
          href="/signup"
          className="ml-2 underline font-semibold"
          data-testid="demo-banner-cta"
        >
          Sign up for a free trial →
        </a>
      </div>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        className="p-1 hover:bg-black/10 rounded shrink-0"
        aria-label="Dismiss"
        data-testid="demo-banner-dismiss"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
